import React from 'react'
import { CircularProgress, FormControl, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { LIST_NULL_OPTION_VALUE } from '../../../helpers/constant';
import { getComparatorSort } from '../../../helpers';

function CommonSelectComponent({label, htmlId, spinner, Placeholder, selected, setSelected, filterOptions, labelKey, valueKey, isLoading, ...props }) {

    // alphabetical sort
    // Memoize sorted data to avoid re-sorting on each render
    const sortedOptions = React.useMemo(() => {
        return [...filterOptions].sort(getComparatorSort('desc', labelKey));
    }, [filterOptions, labelKey]);

    return (
        <FormControl fullWidth sx={{ minWidth: "200px" }} size="small">
            <InputLabel id={`${htmlId}-label`}>{label}</InputLabel>
            <Select
                labelId={`${htmlId}-label`}
                id={htmlId}
                label={label}
                value={selected}
                onChange={async (e) => {
                    setSelected(e.target.value);
                }}
                disabled={spinner}
                endAdornment={
                    isLoading ? (
                        <InputAdornment position="end" sx={{ pr: 2 }}>
                            <CircularProgress size={16} />
                        </InputAdornment>
                    ) : undefined
                }
                {...props}
            >
                {Placeholder ? <MenuItem value={LIST_NULL_OPTION_VALUE} key={"null-value-option"}>{Placeholder}</MenuItem> : ""}
                {sortedOptions.map((option, zid) => (
                    <MenuItem key={zid} value={valueKey ? option[valueKey] : option} name={valueKey ? option[valueKey] : option}>
                        {labelKey ? option[labelKey] : option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default CommonSelectComponent;